'use strict';

module.exports = [function () {
    return {
        restrict: 'A',
        scope: {
            dragulaModel: '='
        },
        require: '^pdDragula',
        link: link
    };

    function link(scope, elem, attrs, pdDragula) {
        scope.$watch("dragulaModel", function(){
            if(scope.dragulaModel){
                pdDragula.addContainer(scope, elem, attrs);
            }
        });
    }
}];
